import { Helmet } from 'react-helmet-async';
import PageTitleWrapper from 'src/components/PageTitleWrapper';
import { Grid, Container } from '@mui/material';
import Footer from 'src/components/Footer';
import PageTitle from '../../../../components/PageTitle';
import Table from '../../../../components/Core/Table';
import { IReportedDetails, ITableColumn } from '../../../../interfaces';
import { useApi } from '../../../../hooks/useApi';
import useToast from '../../../../hooks/useToast';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '../../../../hooks/useMutation';
import { deletePost, getAllPost } from "../../../../services/PostService";
import { deleteReport, getAllReport } from "../../../../services/ReportService";
import { dateFormat } from "../../../../utils";

const tableColumns: ITableColumn[] = [
  {
    id: 'Id',
    accessor: 'Id',
    label: 'Id'
  },
  {
    id: 'Reported by',
    accessor: 'ReportedByName',
    label: 'Reported by'
  },
  {
    id: 'Reported user',
    accessor: 'ReportedUserName',
    label: 'Reported user'
  },
  {
    id: 'Date',
    accessor: (row) => row.AddedOn ? dateFormat(row.AddedOn) : '',
    label: 'Date'
  }
];

const ReportedMessage = () => {
  const { showToast, dissmisToast } = useToast();
  const navigate = useNavigate();
  const {
    data: posts = [],
    isLoading: isFetchingPosts,
    reCall: fetchPosts,
    pagination
  } = useApi(
    'ReportedMessageList',
    () =>
      getAllReport({
        query: '',
        pageNumber: 1,
        pageSize: 1000,
        type: 'MESSAGE'
      }),
    {
      onSuccess: (response) => {
        return response;
      },
      onError: (error: Error) => {
        showToast('error', error.message);
      }
    }
  );

  const deleteReportKey = 'ReportDelete';

  const { isLoading: isDeleteing, mutate: reportDelete } = useMutation(
    deleteReportKey,
    (id: any) => deleteReport(id),
    {
      enabled: false,
      onFire: () => {
        showToast('info', 'Your request is being processed', deleteReportKey);
      },
      onSuccess: (response) => {
        dissmisToast(deleteReportKey);
        fetchPosts();
        showToast('success', response.message || 'Successful');
        return response;
      },
      onError: (error: Error) => {
        dissmisToast(deleteReportKey);
        showToast('error', error.message);
      }
    }
  );




  return (
    <>
      <Helmet>
        <title>Reported Messages</title>
      </Helmet>
      <PageTitleWrapper>
        <PageTitle
          heading="Reported Messages"
        //   buttonLabel="Post"
        //   buttonLink="/dashboard/reported-content/new"
        />
      </PageTitleWrapper>
      <Container maxWidth="lg">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12}>
            <Table
              //   title="Reported Message"
              columns={tableColumns}
              data={posts}
              tablePagination={pagination}



              // onClick={(row: IReportedDetails) => {
              //  navigate('/dashboard/reported/messages/' + row.Id);
              // }}


              onRow={(row: IReportedDetails) => {
                navigate('/dashboard/reported/messages/' + row.Id);
              }}

              isLoading={isFetchingPosts}
              onDelete={(row: IReportedDetails) => {
                if (!isDeleteing) {
                  reportDelete(row.Id);
                }
              }}
            />
          </Grid>
        </Grid>
      </Container>
      <Footer />
    </>
  );
};

export default ReportedMessage;
